import { ReactNode } from 'react';

interface VisuallyHiddenProps {
  /** Content to hide visually but keep accessible to screen readers */
  children: ReactNode;
  /** HTML element to render (default: span) */
  as?: 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

/**
 * Component that hides content visually while keeping it accessible to screen readers.
 * Uses the Tailwind sr-only class for screen reader-only content.
 *
 * Use cases:
 * - Providing additional context for icon-only buttons
 * - Adding form labels that are visually redundant but needed for screen readers
 * - Describing status changes or dynamic content
 *
 * @example
 * <button>
 *   <TrashIcon />
 *   <VisuallyHidden>Delete item</VisuallyHidden>
 * </button>
 */
export default function VisuallyHidden({
  children,
  as: Component = 'span',
}: VisuallyHiddenProps) {
  return (
    <Component className="sr-only">
      {children}
    </Component>
  );
}
